<script lang="ts">
  import { link } from "svelte-navigator";
</script>

<div>
  <center>
    <h1 style="text-shadow: 3px 3px 3px lightgray; font-size: 12em;" class="text-black dark:text-white">404</h1>
    <span>This page doesn't exist. Check the URL, or return <a href="/" use:link>home</a>.</span>
  </center>
</div>
